import React from 'react';
import { JSX } from 'react/jsx-runtime';

const FuelIcon = (
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>,
) => {
  return (
    <svg
      width="19"
      height="20"
      viewBox="0 0 19 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.1031 4.15625H5.28437C4.92812 4.15625 4.60156 4.44856 4.60156 4.82856V8.80394C4.60156 9.15471 4.89844 9.47625 5.28437 9.47625H11.1031C11.4594 9.47625 11.7859 9.18394 11.7859 8.80394V4.82856C11.7562 4.44856 11.4594 4.15625 11.1031 4.15625ZM10.4203 8.16087H5.9375V5.47163H10.4203V8.16087Z"
        fill="#004E9B"
      />
      <path
        d="M18.6445 6.28951L16.3883 4.06797C16.1211 3.80489 15.7055 3.80489 15.4383 4.06797C15.1711 4.33105 15.1711 4.74028 15.4383 5.00335L16.3586 5.90951V7.95566C16.3586 8.30643 16.6555 8.62797 17.0414 8.62797H17.4867V13.0418H16.032V9.50489C16.032 9.15412 15.7352 8.83258 15.3492 8.83258H13.7461V4.00951C13.7461 3.01566 12.9148 2.16797 11.8758 2.16797H4.45391C3.44453 2.16797 2.58359 2.98643 2.58359 4.00951V16.6664H1.66328C1.30703 16.6664 0.980469 16.9587 0.980469 17.3387C0.980469 17.7187 1.27734 18.011 1.66328 18.011H14.6367C14.993 18.011 15.3195 17.7187 15.3195 17.3387C15.3195 16.9587 15.0227 16.6664 14.6367 16.6664H13.7164V10.1772H14.6664V13.7141C14.6664 14.0649 14.9633 14.3864 15.3492 14.3864H18.1398C18.4961 14.3864 18.8227 14.0941 18.8227 13.7141V6.7572C18.8227 6.58182 18.7633 6.40643 18.6445 6.28951ZM3.94922 16.6664V4.00951C3.94922 3.7172 4.18672 3.48335 4.48359 3.48335H11.9055C12.2023 3.48335 12.4398 3.7172 12.4398 4.00951V16.6664H3.94922Z"
        fill="#004E9B"
      />
    </svg>
  );
};

export default FuelIcon;
